/* unplugin-vue-components disabled */import script from "./BookingForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingForm.vue?vue&type=script&setup=true&lang=js"

import "./BookingForm.vue?vue&type=style&index=0&id=6a292b1d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a292b1d"]])

export default __exports__